import {
  bannerComponentMap,
  LayoutElementBanner,
} from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Banner/LayoutElementBanner";
import { Container } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Container";
import {
  LayoutElementProvider,
  LayoutElementRendererData,
} from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { LayoutElementRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Props";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { cn } from "@faire/web/tools/cn";
import * as React from "react";

export const LayoutElementBasedBanner: React.FC<LayoutElementRendererProps> = (
  props
) => {
  const { className, ...rest } = props;
  const layoutElementProps = LayoutElementRendererData.build(rest);

  return (
    <LayoutElementProvider {...layoutElementProps}>
      <Container
        className={cn("rounded-fs-component-default overflow-clip", className)}
      >
        <LayoutElementBanner />
      </Container>
    </LayoutElementProvider>
  );
};

export const isSupportedBanner = (
  type: keyof typeof ILayoutElement.Type | undefined
) => bannerComponentMap.has(type);
